/**
 * 
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */
 import ServiceConstant from "@/app/core/ServiceConstant"
 import MainService from "@/app/services/MainService";
 
 export default class ClinicHistoryService extends MainService {
 
     static listAllPagination(params){
         return this.postSEC(ServiceConstant.PATIENT_MNGT_LIST_PAGED_CLINIC_HISTORY, params);
     }
     
 
 }